const config = {
    rootPath: '#/',
    shareYourJourneyPath: 'shareYourJourney',
    registerUserPath: 'registeredUsers',
    courseEnrollmentsPath: 'courseEnrollments',
    joinUsPath: 'joinUs',
    enrollPath: '/enroll/:program/:course',
    professionalDevelopmentPath: 'professionalDevelopment',
    engineeringCoursesPath: 'engineeringCourses',
    remoteInternshipsPath: 'remoteInternships',
    youTubeVideoUrl: 'https://www.youtube.com/watch?v=TwvbAMlD5sI',
};

export default config;
